import { useFormContext } from 'react-hook-form';
import { RiLightbulbFlashLine, RiRepeatLine } from 'react-icons/ri';

import MultiToggle, { MultiToggleOption } from '@lib/core/src/components/MultiToggle';
import palette from '@lib/core/src/theme/palette';
import { styled } from '@mui/material';

import { WorkflowScheduledTriggerDtoDaysOfWeekItem } from '@/api/generated';
import { Card } from '@/components/AiWorkflow/AiWorkflowStyles';
import { ALL_DAYS_OF_WEEK } from '@/components/AiWorkflow/formSchema';

const Container = styled(Card)({
  gap: 35
});

const Header = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16
});

const IconBox = styled('div')({
  width: 44,
  height: 44,
  borderRadius: 24,
  background: palette.backgrounds[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const Title = styled('div')({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 16,
  color: palette.black
});

const Description = styled('div')({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 13,
  color: palette.grey[500]
});

const options: MultiToggleOption[] = [
  {
    label: 'Every Day',
    value: 'every_day',
    icon: (
      <IconBox sx={{ background: 'transparent' }}>
        <RiRepeatLine size={16} />
      </IconBox>
    )
  },
  {
    label: 'Every Monday',
    value: WorkflowScheduledTriggerDtoDaysOfWeekItem.MONDAY,
    icon: (
      <IconBox sx={{ background: 'transparent' }}>
        <RiRepeatLine size={16} />
      </IconBox>
    )
  }
];

const Trigger = () => {
  const { setValue, watch } = useFormContext();
  const value = watch('trigger') || [];

  const handleChange = (val: string) => {
    if (val === 'every_day') {
      setValue('trigger', ALL_DAYS_OF_WEEK);
    } else if (val === WorkflowScheduledTriggerDtoDaysOfWeekItem.MONDAY) {
      setValue('trigger', [WorkflowScheduledTriggerDtoDaysOfWeekItem.MONDAY]);
    }
  };

  const selectedValue =
    value.length === ALL_DAYS_OF_WEEK.length && ALL_DAYS_OF_WEEK.every(day => value.includes(day))
      ? 'every_day'
      : value[0] || '';

  return (
    <Container>
      <Header>
        <IconBox>
          <RiLightbulbFlashLine size={20} color={palette.pink[100]} />
        </IconBox>
        <div>
          <Title>Trigger</Title>
          <Description>When should this agent work?</Description>
        </div>
      </Header>
      <MultiToggle options={options} value={selectedValue} onChange={handleChange} />
    </Container>
  );
};

export default Trigger;
